import useAppState from '../../../context/AppContext';
import { IContactType } from '../../../context/model';
import MgpFormInput from '../../../elements/MgpFormInput/MgpFormInput';
import MgpFormRadio from '../../../elements/MgpFormRadio/MgpFormRadio';
import { UseFormGetValues, UseFormRegister, UseFormSetValue, UseFormWatch } from 'react-hook-form';
import { formatDateFR } from '../../../utils/utils';


type SituationInfoFormComponentProps = {
    register: UseFormRegister<any>;
    errors: any;
    setValue?: UseFormSetValue<any>;
    getValues?: UseFormGetValues<any>;
    watch: UseFormWatch<any>
}



export default function SituationInfoFormComponent({register, errors, setValue,watch} : Readonly<SituationInfoFormComponentProps>) {

    const {
    state: { proposition }
    } = useAppState();
    
    const isClient = proposition?.configuration?.byContactType === IContactType.CLIENT;

    return (             
        <>
            <h2 className='card-title bleu mb-md'>Ma situation </h2>
            <div className='form-row mb-sm'>
                <div className="form-group mw-50">
                    <MgpFormInput
                        label="Date de départ à la retraite"
                        id="retirementDate"
                        labelFontWeight='medium'
                        type='date'
                        register={register}
                        errors={errors}
                        required={true}
                        min='1950-01-01'
                        mgpTooltipText="Vous devez <strong>bien indiquer le mois de départ à la retraite </strong> (et non pas le dernier mois travaillé) pour que le <strong>montant de votre cotisation soit bien calculé en fonction de votre premier jour de retraite</strong>."
                    />
                </div>
            </div> 

          

            <div className='form-row mb-sm'>
                <div className="form-group mw-50">
                    <MgpFormInput
                        label="Date de naissance"
                        id="birthDate"
                        labelFontWeight='medium'
                        type='date'
                        register={register}
                        errors={errors}
                        required={!isClient}
                        readOnly={isClient}
                        value={isClient ? proposition?.contact?.birthDate : watch('birthDate')}
                        // onChange={e=> console.log(e.target.value)}

                    />
                </div>
            </div>   

            <div className="">
                <p className='form-check-label fw-medium text'>Etes-vous bénéficiaire du régime Alsace-Moselle ? <span className='fushia'> (*)</span></p>
                <div className="form-row va-center jc-start" style={{width: "max-content"}}>
                    <MgpFormRadio id ='alsaceMoselleRegime' value='true' register={register} label="Oui" errors={errors} />
                    <MgpFormRadio id ='alsaceMoselleRegime' value='false' register={register} label="Non" errors={errors} />
                </div>        
            </div>

            <div className="mt-xl">
                <p className='text fw-medium'><span className='fushia'>(*)</span> Champs obligatoires</p>
            </div>  
              
        </>         
  )
}
